import { render, staticRenderFns } from "./CoreInput.vue?vue&type=template&id=31b77dfa&scoped=true&"
import script from "./CoreInput.vue?vue&type=script&lang=js&"
export * from "./CoreInput.vue?vue&type=script&lang=js&"
import style0 from "./CoreInput.vue?vue&type=style&index=0&id=31b77dfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b77dfa",
  null
  
)

export default component.exports